import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withFormik } from 'formik';
import Yup from 'yup';
import { isValidPhone } from 'shared/validations/validations';
import { addPhone, authWithPhone, resendVerifyCode, deletePhone } from 'shared/actions/user';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const PHONE_LENGTH = 12;

const mapStateToProps = state => ({
  id: state.user.user.id,
  email: state.user.user.email,
  phones: state.user.user.phones,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      onVerifyPhone: authWithPhone,
      onGetVerifyCode: addPhone,
      onResendCode: resendVerifyCode,
      onDeletePhone: deletePhone,
    },
    dispatch,
  );

const ERROR_MESSAGE_REQUIRED = 'Поле обязательно';
const ERROR_MESSAGE_EMAIL = 'Некорректный почтовый адрес';
const ERROR_MESSAGE_PHONE = 'Некорректный телефон';

const profileValidation = {
  validationSchema: Yup.object().shape({
    email: Yup.string()
      .required(ERROR_MESSAGE_REQUIRED)
      .email(ERROR_MESSAGE_EMAIL),
    phones: Yup.array(
      Yup.object().shape({
        number: Yup.string()
          .min(PHONE_LENGTH, ERROR_MESSAGE_PHONE)
          .test('is-jimmy', ERROR_MESSAGE_PHONE, value => isValidPhone(value)),
      }),
    ),
  }),

  mapPropsToValues: ({ email, phones }) => ({
    email: email || '',
    phones: phones || ['380'],
    phoneLength: 12,
  }),
  displayName: 'ProfileContacts',
};

const withAddContactLogic = ContactForm =>
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(
    withFormik(profileValidation)(
      class extends Component {
        static propTypes = {
          phones: PropTypes.arrayOf(PropTypes.shape()),
          email: PropTypes.string,
          id: PropTypes.number.isRequired,
          onResendCode: PropTypes.func.isRequired,
          onGetVerifyCode: PropTypes.func.isRequired,
          onVerifyPhone: PropTypes.func.isRequired,
          // Formik
          values: PropTypes.shape().isRequired,
          setFieldValue: PropTypes.func.isRequired,
          setFieldTouched: PropTypes.func.isRequired,
          setSubmitting: PropTypes.func.isRequired,
          onDeletePhone: PropTypes.func.isRequired,
        };

        static defaultProps = {
          phones: [],
          email: '',
        };

        state = {
          isRecentlySendCode: false,
          error: '',
        };

        componentWillReceiveProps(nextProps) {
          if (this.props.phones !== nextProps.phones) {
            this.props.setFieldValue('phones', nextProps.phones);
          }
          if (this.props.email !== nextProps.email) {
            this.props.setFieldValue('email', nextProps.email);
          }
        }

        onClickAddPhone = () => {
          const { setFieldValue, values } = this.props;
          const { phones } = values;

          setFieldValue('phones', phones.concat({ number: '380', is_verified: undefined }));
        };

        onRemovePhone = index => {
          const { setFieldValue, setFieldTouched, values } = this.props;
          const { phones } = values;

          this.setState({ error: '' });
          setFieldTouched(`phones[${index}]`, false);
          setFieldValue('phones', [...phones.slice(0, index), ...phones.slice(index + 1)]);
        };

        onDeletePhone = id => {
          this.props.onDeletePhone(id);
        };

        getVerifyCode = phone => {
          const { onGetVerifyCode, id, setSubmitting } = this.props;

          setSubmitting(true);
          onGetVerifyCode({ user: id, phone: phone.replace(/[+\s_()]/g, '') }).then(
            () => {
              this.setState({ isRecentlySendCode: false });
              this.setState({ error: '' });
              setSubmitting(false);
            },
            error => {
              this.setState({ error: error.message });
              setSubmitting(false);
            },
          );
        };

        setResentlySendCode = () => {
          this.setState({ isRecentlySendCode: true });
          setTimeout(() => {
            this.setState({ isRecentlySendCode: false });
          }, 60000);
        };

        setPhoneOrder = isVerified => {
          switch (isVerified) {
            case true:
              return 1;
            case false:
              return 2;
            default:
              return 3;
          }
        };

        resendVerifyCode = phone => {
          this.props.onResendCode({ phone: phone.replace(/[+\s_()]/g, '') });
          this.setResentlySendCode();
        };

        removeError = () => {
          this.setState({ error: '' });
        };

        verifyPhone = data => {
          const { phone, code } = data;
          const { onVerifyPhone, setSubmitting } = this.props;

          setSubmitting(true);
          onVerifyPhone({ code, phone: phone.replace(/[+\s_()]/g, '') }).then(
            () => {
              this.setState({ isRecentlySendCode: false });
              this.setState({ error: '' });
              setSubmitting(false);
            },
            error => {
              this.setState({ error: error.message });
              setSubmitting(false);
            },
          );
        };

        render() {
          const { isRecentlySendCode, error } = this.state;
          const phones = this.props.values.phones;

          const newProps = {
            getVerifyCode: this.getVerifyCode,
            resendVerifyCode: this.resendVerifyCode,
            verifyPhone: this.verifyPhone,
            onRemovePhone: this.onRemovePhone,
            onClickAddPhone: this.onClickAddPhone,
            setPhoneOrder: this.setPhoneOrder,
            isRecentlySendCode,
            removeError: this.removeError,
            phones,
            serverError: error,
          };

          return (
            <div>
              <ContactForm {...this.props} {...newProps} />
            </div>
          );
        }
      },
    ),
  );

export default withAddContactLogic;



// WEBPACK FOOTER //
// ./src/shared/hocs/withAddContactLogic.js